export const filenameCompliant = (string) => {
  const regexToRemoveSpecialChars = /[^a-z0-9_-]/i;
  return string?.replace(regexToRemoveSpecialChars, '');
};

export const playlistNameCompliant = (string) => {
  const regexToRemoveSpecialChars = /[^a-z0-9_-\s]/i;
  return string?.replace(regexToRemoveSpecialChars, '');
};

export const matchIdCompliant = (string) => {
  const regexToRemoveSpecialChars = /[^0-9\s]/i;
  return string?.replace(regexToRemoveSpecialChars, '');
};

export default { filenameCompliant };
